import { fetchData, postData } from "./apis";

const path = "/quotation";

export const apiQuotationDeleteApi = (value) => {
  let endPoint = `${path}/sales-quotation-delete`;
  return postData(endPoint, value);
};

export const getSalesQuatataionInvoiceApi = (value) => {
  let endPoint = `${path}/get-sales-quotation-invoice`;
  return postData(endPoint,value);
};
